/* eslint-disable prettier/prettier */

// App ドメイン
export const APP_ROOT: string = process.env.VUE_APP_ROOT ?? '';

// Apiドメイン
export const APP_API_ROOT: string = process.env.VUE_APP_API_ROOT ?? '';
export const COMMON_API_ROOT: string =
  process.env.VUE_APP_COMMON_API_ROOT ?? '';

export const APP_AUTH_ROOT: string = process.env.VUE_APP_AUTH_ROOT ?? '';

export const APP_SHARE_ROOT: string = process.env.VUE_APP_SHARE_ROOT ?? '';
export const APP_SHARE_PATH: string = process.env.VUE_APP_SHARE_PATH ?? '';

// 統合管理静的コンテンツ
export const APP_TM_SCONTENT: string = process.env.VUE_APP_TM_SCONTENT ?? '';

export const EXTERNAL_CONNECTION: boolean =
  process.env.VUE_APP_EXTERNAL_CONNECTION == 'true' ?? false;

// タイムゾーン
export const TIMEZONE: string = process.env.VUE_APP_TIMEZONE ?? '';

// バージョン
export const VERSION: string = process.env.VUE_APP_VERSION ?? '';

// セッションID保存トークンキー
export const TOKEN_COOKIE_NAME: string =
  process.env.VUE_APP_TOKEN_COOKIE_NAME ?? '';

// データ共有用セッションID保存トークンキー
export const VIEWER_TOKEN_COOKIE_NAME: string =
  process.env.VUE_APP_VIEWER_TOKEN_COOKIE_NAME ?? '';

// 表示ユーザーIDキー
export const SHOWN_USER_ID: string = process.env.VUE_APP_SHOWN_USER_ID ?? '';

// 本番環境では非表示の項目(true: 非表示 / false: 表示)
export const PROD_HIDE_ITEM: boolean =
  process.env.VUE_APP_PROD_HIDE_ITEM == 'true' ?? false;

// プライバシーポリシーのURL
export const PRIVACY_POLICY_URL = process.env.VUE_APP_PRIVACY_POLICY_URL ?? '';

export const ADDRESS_SEARCH_API_ROOT =
  process.env.VUE_APP_ADDRESS_SEARCH_API_ROOT ?? '';

// 他アプリとの連携を表示する()
export const OTHER_APP_LINKAGE: string[] =
  process.env.VUE_APP_OTHER_APP_LINKAGE?.split(',') ?? ([''] as string[]);

// fitbitの連携サイトURL
export const FITBIT_URL: string = process.env.VUE_APP_FITBIT_URL ?? '';

//郵便追跡サービス
export const JAPAN_POST_URL: string = process.env.VUE_APP_SHOW_JAPAN_POST ?? '';
export const JAPAN_POST_URL_SECOND: string =
  process.env.VUE_APP_SHOW_JAPAN_POST_SECOND_URL ?? '';

// 法人コンテンツURL
export const CORPORATE_URL: string = process.env.VUE_APP_CORPORATE_URL ?? '';

// マイナポータル本人確認API URL
export const MYNA_PORTAL_AUTHORIZE_URL : string = process.env.VUE_APP_MYNA_PORTAL_AUTHORIZE_URL ?? '';
// マイナポータル本人確認API クライアントID
export const MYNA_PORTAL_CLIENT_ID: string = process.env.VUE_APP_MYNA_PORTAL_CLIENT_ID ?? '';

// VeriTrans4G MDKトークン取得 URL
export const MDK_TOKEN_API_URL : string = process.env.VUE_APP_MDK_TOKEN_API_URL ?? '';
